import { fetch } from "../network";
import { financialBreakdownConfigs } from "./configs";

export function FinancialBreakdownController() {
	const getFinancialAnalysis = async (id) => {
		const config = financialBreakdownConfigs.get_financial_analysis;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateFinancialAnalysis = async (body) => {
		const config = financialBreakdownConfigs.update_financial_analysis;
		const endpoint = config.endpoint.replace("$id", body.id);
		delete body.id;
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getSourcesAndUses = async (id) => {
		const config = financialBreakdownConfigs.get_sources_and_uses;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateSourcesAndUses = async (body) => {
		const config = financialBreakdownConfigs.update_sources_and_uses;
		const endpoint = config.endpoint.replace("$id", body.id);
		delete body.id;
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getAssetBreakdown = async (id) => {
		const config = financialBreakdownConfigs.get_asset_breakdown;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateAssetBreakdown = async (body) => {
		const config = financialBreakdownConfigs.update_asset_breakdown;
		const endpoint = config.endpoint.replace("$id", body.id);
		delete body.id;
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getEquityBreakdown = async (id) => {
		const config = financialBreakdownConfigs.get_equity_breakdown;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateEquityBreakdown = async (body) => {
		const config = financialBreakdownConfigs.update_equity_breakdown;
		const endpoint = config.endpoint.replace("$id", body.id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body.rows)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getFinancialInfo = async (id) => {
		const config = financialBreakdownConfigs.get_financial_info;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateFinancialInfo = async (body) => {
		const config = financialBreakdownConfigs.update_financial_info;
		const endpoint = config.endpoint.replace("$id", body.id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getAdvancedFinancialInfo = async (id) => {
		const config = financialBreakdownConfigs.get_advanced_financial_info;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateAdvancedFinancialInfo = async (body) => {
		const config = financialBreakdownConfigs.update_advanced_financial_info;
		const endpoint = config.endpoint.replace("$id", body.id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getUseOfFunds = async (id) => {
		const config = financialBreakdownConfigs.get_use_of_funds;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateUseOfFunds = async (body) => {
		const config = financialBreakdownConfigs.update_use_of_funds;
		const endpoint = config.endpoint.replace("$id", body.id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};


	const getSupportingDocuments = async (id) => {
		const config = financialBreakdownConfigs.get_supporting_documents;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateSupportingDocuments = async (body) => {
		const config = financialBreakdownConfigs.update_supporting_documents;
		const endpoint = config.endpoint.replace("$id", body.id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body.documents)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getScenarioAnalysis = async (id) => {
		const config = financialBreakdownConfigs.get_scenario_analysis;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateScenarioAnalysis = async (body) => {
		const config = financialBreakdownConfigs.update_scenario_analysis;
		const endpoint = config.endpoint.replace("$id", body.id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body.scenarios)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	return Object.freeze({
		getFinancialAnalysis,
		updateFinancialAnalysis,
		getSourcesAndUses,
		updateSourcesAndUses,
		getAssetBreakdown,
		updateAssetBreakdown,
		getEquityBreakdown,
		updateEquityBreakdown,
		getFinancialInfo,
		updateFinancialInfo,
		getAdvancedFinancialInfo,
		updateAdvancedFinancialInfo,
		getUseOfFunds,
		updateUseOfFunds,
		getSupportingDocuments,
		updateSupportingDocuments,
		getScenarioAnalysis,
		updateScenarioAnalysis,
	});
}
